import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { EMPTY_SHIP_FROM_ADDRESS } from '@shipstation/client-common/types/ship-from';
import type { ShipFrom, ShipFromAddress } from '@shipstation/client-common/types/ship-from';
import type { ShipFromOption } from '@shipstation/client-common/components/freight-browser';

import Global from '../../store/global-selectors';

type ShipFromResolution = {
  shipFromOptions: ShipFromOption[];
  shipFromAddress: ShipFromAddress;
};

export const useShipFromResolution = (selectedShipFromId: string): ShipFromResolution => {
  const sellerData = useSelector(Global.selectSellerData);

  const shipFromOptions = useMemo(() => {
    const shipFroms: ShipFrom[] = sellerData?.shipFroms ?? [];
    return shipFroms.map((sf) => ({
      id: String(sf.shipFromId),
      name: sf.name,
      address: sf.originAddress
        ? {
            line1: sf.originAddress.line1,
            line2: sf.originAddress.line2,
            city: sf.originAddress.city,
            state: sf.originAddress.state,
            postalCode: sf.originAddress.postalCode,
            countryCode: sf.originAddress.countryCode,
            ianaTimeZone: sf.originAddress.ianaTimeZone,
          }
        : undefined,
      ltlDefaults: sf.ltlDefaults ?? null,
    }));
  }, [sellerData]);

  const shipFromAddress = useMemo(() => {
    const shipFroms: ShipFrom[] = sellerData?.shipFroms ?? [];
    const matched = shipFroms.find((sf) => String(sf.shipFromId) === selectedShipFromId);
    return matched?.originAddress ?? EMPTY_SHIP_FROM_ADDRESS;
  }, [sellerData, selectedShipFromId]);

  return { shipFromOptions, shipFromAddress };
};
